module.exports = __webpack_public_path__ + "img/jasmine.be5030ca.webp";